import * as modal from "../util/modal.ts";
import * as Html from "../util/Html.ts";
import ApiServer from "../ApiServer.js";
import * as Storage from "../lib/Storage.ts";
import * as FwDatas from "../FwDatas.ts";
import * as Confetti from "../lib/Confetti.js";

import TPL_PREMIUM from "../modal/premium.mustache";
import TPL_PREMIUM_ADS from "../modal/premium_ads.mustache";
import TPL_PREMIUM_PROMO from "../modal/premium_promo.mustache";
import { format } from "../lib/DateUtils.ts";

Html.register({
  async takepremium(from){
    let 
      family = FwDatas.getFamily(),
      user = FwDatas.getUser(),
      
      data = {
        directclick:from==='directclick'||from==='promo',
        blocked:user.isKid()
      },
      activeCredits = await ApiServer.customcreditget() ;
    
    if(activeCredits.length){
      data.membercard = {
        avatars:family.members.slice(0,5).map((member,idx)=>{return{thumb:member.thumb(),left:24*idx}}),
        extra: Math.max(family.members.length-5,0),
        extraLeft : 24*5,
        date: format(activeCredits[0].creationDate,'MMMM YYYY')
      }
      data.nameOfPremiumProvider = activeCredits[0].author().name;
      Confetti.start(2000)
      modal.openModal(TPL_PREMIUM,data);
      return;
    }
  
    ApiServer.credit2checkouturl2(function(twocheckoutUrls){
      data.twocheckoutUrls = twocheckoutUrls;
      var fromStorage = Storage.sessionGet('waitingpremium');
      if(fromStorage){
        data.waitingpremium = (new Date() - new Date(fromStorage) < 600000) 
      }
      if(twocheckoutUrls.yearlyPromo){
        twocheckoutUrls.yearlyPromo.oldPrice = twocheckoutUrls.yearly.price
        twocheckoutUrls.yearlyPromo.promoPercent = Math.round(twocheckoutUrls.yearlyPromo.percent*100)
        modal.openModal(TPL_PREMIUM_PROMO,data);
      }else{
        modal.openModal(TPL_PREMIUM,data);
      }
    })
  },
  async takepremiumfromads(){
    let 
      user = FwDatas.getUser(),
      twocheckoutUrls = await ApiServer.credit2checkouturl2(),
      monthly = toMonthly(twocheckoutUrls.yearly.price);
    
    modal.openModal(TPL_PREMIUM_ADS,{
      buyUrl : twocheckoutUrls.yearly.buyUrl,
      monthly,
      yearly : twocheckoutUrls.yearly.price,
      blocked:user.isKid()
    });
    
  },
  takepremiumblocked(){
    modal.simple({
      title:"premium.blockedtitle",
      lottie:"images/lottie/anim_teddy_bear.json",
      message:"premium.blockeddescription",
      button:"premium.blockedbutton"
    })
  }
});

function toMonthly(yearly){
  var
    cleanYearly = yearly.replace(/[^0-9\.,]/g,""),
    hasComma = cleanYearly.indexOf(',')>-1;
  
  if(hasComma){
    cleanYearly = cleanYearly.replace(',','.');
  }  
  var monthly = (parseFloat(cleanYearly)/12).toFixed(2);
  if(hasComma) monthly = monthly.replace('.',',')

  //on remplace le numerique dans le yearly par le nouveau pour bien avant $ ou € avant ou après selon la monnaie
  return yearly.replace(/(\d|\.|\s|,)+/,monthly)
}